/**
 * Tracking utilities for extracting UTM and ad parameters from URL
 *
 * These parameters should be added to links from zaptime.cz/zaptime.app → my.zaptime.app
 * See docs/ANALYTICS_SETUP.md for implementation details on the web repository
 */

export interface CrossDomainParams {
    ph_distinct_id?: string; // PostHog user ID for cross-domain identity
    ph_session_id?: string; // PostHog session ID for continuous session/recording across domains
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_content?: string;
    utm_term?: string;
    gclid?: string; // Google Click ID
    fbclid?: string; // Facebook Click ID
}

/**
 * Extract tracking parameters from the current URL
 * Called automatically on app initialization to capture attribution data
 */
export const extractTrackingParams = (): CrossDomainParams => {
    const params = new URLSearchParams(window.location.search);

    return {
        ph_distinct_id: params.get("ph_distinct_id") || undefined,
        ph_session_id: params.get("ph_session_id") || undefined,
        utm_source: params.get("utm_source") || undefined,
        utm_medium: params.get("utm_medium") || undefined,
        utm_campaign: params.get("utm_campaign") || undefined,
        utm_content: params.get("utm_content") || undefined,
        utm_term: params.get("utm_term") || undefined,
        gclid: params.get("gclid") || undefined,
        fbclid: params.get("fbclid") || undefined,
    };
};
